export default __webpack_public_path__ + "static/media/RockinTuna-TeamBG-m-2x.6bfb7e68.jpg";